import { useState } from "react";
import { Package, Store } from "lucide-react";
import clsx from "clsx";
import { Badge } from "components/ui/badge";
import { Button } from "components/ui/button";

const tabs = [
  {
    label: "Product",
    value: "product",
    icon: Package,
  },
  {
    label: "Shop",
    value: "shop",
    icon: Store,
  },
];

export default function ProductShopToggle() {
  const [activeTab, setActiveTab] = useState("product");

  return (
    <div className="flex w-fit space-x-2">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.value;

        return (
          <Button variant={isActive ? "secondary" : "outline"} className="gap-2 m-0 w-28 " onClick={() => setActiveTab(tab.value)}>
            <Icon className="w-4 h-4" />
            {tab.label}
          </Button>
          // <button
          //   key={tab.value}
          //   onClick={() => setActiveTab(tab.value)}
          //   className={clsx(
          //     "flex flex-1 items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors",
          //     isActive ? "bg-primary text-white" : "text-gray-400 hover:text-white"
          //   )}
          // >

          // </button>
        );
      })}
    </div>
  );
}

